import { defineComponent, h } from 'vue'
import { Facebook, Github, Instagram, Linkedin, Podcast, Rss, Twitch, Twitter, Youtube } from 'lucide-vue-next'

/**
 * Ícones de redes sociais que o lucide não tem, no mesmo traço dele (24x24, contorno de 2px),
 * para ficarem iguais aos demais no seletor de ícones e no site. Desenhos do Tabler Icons (MIT).
 */
const criarIcone = (nome, caminhos) => defineComponent({
    name: nome,
    inheritAttrs: false,
    setup(_, { attrs }) {
        return () => h('svg', {
            xmlns: 'http://www.w3.org/2000/svg',
            width: 24,
            height: 24,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 2,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            ...attrs,
        }, caminhos.map((d) => h('path', { d })))
    },
})

export const WhatsApp = criarIcone('WhatsApp', [
    'M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9',
    'M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1',
])

export const TikTok = criarIcone('TikTok', [
    'M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z',
])

export const Telegram = criarIcone('Telegram', [
    'M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4',
])

export const XTwitter = criarIcone('XTwitter', [
    'M4 4l11.733 16h4.267l-11.733 -16z',
    'M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772',
])

export const Threads = criarIcone('Threads', [
    'M19 7.5c-1.333 -3 -3.667 -4.5 -7 -4.5c-5 0 -8 2.5 -8 9s3.5 9 8 9s7 -3 7 -5s-1 -5 -7 -5c-2.5 0 -3 1.25 -3 2.5c0 1.5 1 2.5 2.5 2.5c2.5 0 3.5 -1.5 3.5 -5s-2 -4 -3 -4s-1.833 .333 -2.5 1',
])

export const Spotify = criarIcone('Spotify', [
    'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
    'M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527',
    'M9 15c1.5 -1 4 -1 5 .5',
    'M7 9c2 -1 6 -2 10 .5',
])

export const Pinterest = criarIcone('Pinterest', [
    'M8 20l4 -9',
    'M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7',
    'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
])

/**
 * Redes sociais na ordem em que aparecem no seletor de ícones (nome no iconMap => componente).
 */
export const iconesRedesSociais = {
    WhatsApp,
    Instagram,
    Facebook,
    Youtube,
    TikTok,
    XTwitter,
    Twitter,
    Threads,
    Telegram,
    Linkedin,
    Spotify,
    Pinterest,
    Twitch,
    Github,
    Podcast,
    Rss,
}

export const NOMES_REDES_SOCIAIS = Object.keys(iconesRedesSociais)
